import { PublicClientApplication, EventType, InteractionType } from '@azure/msal-browser'
import { msalConfig } from './authConfig'

const authInstance = new PublicClientApplication(msalConfig)

const setActiveAccount = () => {
    const accounts = authInstance.getAllAccounts()
    if (accounts.length > 0) {
        authInstance.setActiveAccount(accounts[0])
    }
}

setActiveAccount();

authInstance.addEventCallback(message => {
    switch (message.eventType) {
        case EventType.LOGIN_SUCCESS:
        case EventType.ACQUIRE_TOKEN_SUCCESS:
            if (message.interactionType === InteractionType.Redirect) {
                setActiveAccount()
            }
    }
})

export default authInstance
